
<template>
  <div>
    <v-card>
      <v-card-subtitle>Listar</v-card-subtitle>
      <v-card-text class="text-right">
        <v-btn small class="primary" @click="cargar()">Buscar</v-btn>
      </v-card-text>
      <v-card-text>
        <v-simple-table>
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">ID</th>
                <th class="text-left">Nombre</th>
                <th class="text-left">Descripcion</th>
                <th class="text-left">Ind Activo</th>
                <th class="text-left">Accion</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in Lista" :key="item.id">
                <td>{{ item.id }}</td>
                <td>{{ item.nombre }}</td>
                <td>{{ item.descripcion }}</td>
                <td>{{ item.ind_activo }}</td>
                <td>
                  <v-btn icon @click="GetEditar(item)">
                    <v-icon color="info">{{ icons.mdiPencil }}</v-icon>
                  </v-btn>
                  <v-btn icon>
                    <v-icon color="error" v-if="item.ind_activo">{{ icons.mdiCancel }}</v-icon>
                    <v-icon color="success" v-else>{{ icons.mdiCheck }}</v-icon>
                  </v-btn>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-card-text>
      <!-- Table -->
    </v-card>
  </div>
</template>
  
<script>
import { onBeforeMount, ref, context, watch } from '@vue/composition-api'
import {
  mdiMagnify,
  mdiDeleteOutline,
  mdiStoreEdit,
  mdiPencilOutline,
  mdiAccountCancel,
  mdiAccountEdit,
  mdiAccountCheck,
  mdiCheck,
  mdiCancel,
  mdiStoreEditOutline,
  mdiPencil,
  mdiCached,
} from '@mdi/js'
import config from '@/api/config'
import store from '@/store'
import ContabilidadService from '@/api/servicios/ContabilidadService'

export default {
  components: {},
  setup(props, context) {
    const search = ref('')
    const Lista = ref([])
    const ListaLoad = ref(false)
    const cargandoDatos = ref(false)
    const filtroInit = {
      valor: '',
      id_categoria: null,
      id_sub_categoria: null,
      id_unidad_medida: null,
      id_producto_tipo: null,
      estado: null,
    }
    const filtro = ref(JSON.parse(JSON.stringify(filtroInit)))
    const GetEditar = item => {
      console.log(item)
      context.emit('GetEditar', { ...item })
    }
    onBeforeMount(() => {
      cargar()
    })
    const CambiarEstado = () => {
      guardando.value = true

      try {
        ContabilidadService.centroCostoNuevo({ ...datos.value, id_empleado: store.state.user.id_empleado })
          .then(response => {
            console.log(response)
            if (response.data.mensaje == 'GUARDADA CON EXITO') {
              store.commit('setAlert', {
                message: response.data.mensaje,
                type: 'success',
              }) 
              limpiar()
            } else {
              store.commit('setAlert', {
                message: `${response.data.mensaje}: `,
                type: 'warning',
              })
            }
          })
          .catch(error => {
            console.log(error)
            store.commit('setAlert', {
              message: error,
              type: 'error',
            })
          })
          .finally(() => {
            guardando.value = false
          })
      } catch (error) {
        store.commit('setAlert', {
          message: error,
          type: 'error',
        })
      }
    }
    const cargar = () => {
      cargandoDatos.value = true
      try {
        ContabilidadService.centroCostoListar()
          .then(response => {
            console.log(response)
            if (response.data.mensaje == 'BUSQUEDA_EXITOSA') {
              Lista.value = response.data.datos
            }
          })
          .catch(error => {
            console.log(error)
          })
          .finally(() => {
            cargandoDatos.value = false
          })
      } catch (error) {
        store.commit('setAlert', {
          message: error,
          type: error,
        })
        cargandoDatos.value = false
      }
    }
    return {
      icons: {
        mdiMagnify,
        mdiDeleteOutline,
        mdiPencilOutline,
        mdiAccountCancel,
        mdiAccountEdit,
        mdiAccountCheck,
        mdiCheck,
        mdiCancel,
        mdiStoreEdit,
        mdiStoreEditOutline,
        mdiPencil,
        mdiCached,
      },
      search,
      headers: [
        { text: 'Id', value: 'id' },
        { text: 'Nombre', value: 'nombre' },
        { text: 'Descripcion', value: 'descripcion' },
        { text: 'Activo', value: 'ind_activo' },
        { text: 'Accion', value: 'accion', sortable: false },
      ],
      Lista,
      ListaLoad,
      cargar,
      cargandoDatos,
      GetEditar,
    }
  },
}
</script>
  
<style lang="scss" scoped>
.table-kitchen-sink ::v-deep {
  .v-data-table-header {
    white-space: nowrap;
  }
}
</style>
  